module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "springio-icon.4ba58d7e.svg" + "?" + Date.now();